import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CircularProgress, Typography } from "@mui/material";
import { apiRequest } from "../utils";
import pageStyle from "./LoginPage.module.css";

// Google sends the user back here with a one-time code after they allow
// access. Hand it to the API exactly once, then return to Settings.
function GmailAuthPage() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const nav = useNavigate();
  const sent = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (sent.current) {
      return;
    }
    sent.current = true;
    const token = localStorage.getItem("token");
    apiRequest
      .post(
        "/setup/gmail/set",
        { code },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => nav("/settings"))
      .catch((e) =>
        setError(
          e.response?.status === 403
            ? "Only managers can connect the Google account."
            : "Connecting Google failed. Go back to Settings and try again."
        )
      );
  }, [code, nav]);

  return (
    <div className={pageStyle.loginContainer}>
      {error ? (
        <>
          <Typography color="error">{error}</Typography>
          <a href="/settings">Back to Settings</a>
        </>
      ) : (
        <>
          <CircularProgress />
          <Typography color="text.secondary">Connecting Google…</Typography>
        </>
      )}
    </div>
  );
}

export default GmailAuthPage;
